import Modal from '@components/modal'
import Typography from '@components/typography'
import Column from '@components/column'
import Image from '@components/image'
import Row from '@components/row'
import Button from '@components/button'
import Svg from '@components/svg'
import { useEffect, useRef, useState } from 'react'
const Incoming = ({ visible, sender, onEnd, onAnswer }) => {
  const ref = useRef(null)
  const [incomingAudio] = useState(
    new Audio(require('@assets/incoming_ring.mp3')),
  )

  const stopIncomingAudio = () => {
    incomingAudio.pause()
    incomingAudio.currentTime = 0
  }

  const playIncomingAudio = () => {
    incomingAudio.loop = true
    incomingAudio.volume = 0.7
    incomingAudio.play().catch((err) => {
      console.error('Audio playback failed:', err)
    })
  }

  const handleUnlockAudio = () => {
    playIncomingAudio()
  }

  useEffect(() => {
    ref.current.click()
  }, [])

  useEffect(() => {
    return () => stopIncomingAudio()
  }, [])

  return (
    <Modal visible={visible} hasCross={false}>
      <button ref={ref} style={{ display: 'none' }} onClick={handleUnlockAudio}>
        Click
      </button>
      <Column alignItems="center" rowGap={10}>
        <Image
          src={`${process.env.BUCKET_URL}/${sender?.avatar}`}
          width={50}
          height={50}
          styleImage="border-radius:50%;"
        />
        <Typography content={sender?.name} size={18} weight={600} />
        <Typography content={'is Calling You'} size={14} tc="placeholder" />
        <Row colGap={20}>
          <Button
            bg="danger"
            title="End"
            leftComponent={<Svg svg="call" color={'white'} />}
            onClick={onEnd}
          />
          <Button
            bg="success"
            title="Answer"
            leftComponent={<Svg svg="call" color={'white'} />}
            onClick={onAnswer}
          />
        </Row>
      </Column>
    </Modal>
  )
}

export default Incoming
